import { Module } from 'wrapper6'

export default class MegaMenu extends Module {
    ready (app) {
        const megaMenus = document.querySelectorAll('.mtt-mega-menu')
        const megaMenuInnerLinks = document.querySelectorAll('.mtt-mega-menu .sub-menu a')

        if (megaMenus.length) {
            megaMenus.forEach(menu => menu.addEventListener('mouseenter', event => this.addFirstActiveClass(event)))
            megaMenuInnerLinks.forEach(link => link.addEventListener('mouseenter', () => this.removeFirstActiveClass()))
            megaMenus.forEach(menu => menu.addEventListener('mouseleave', () => this.removeFirstActiveClass()))

            megaMenus.forEach(menu => {
                const subMenu = menu.querySelector('.sub-menu')
                const menuContent = menu.querySelector('.mtt-mega-menu-content')
                const menuTitle = menuContent.querySelector('.mtt-title-section')
                const menuImage = menuContent.querySelector('.mtt-menu-image-wrap')

                subMenu.prepend(menuTitle)
                subMenu.appendChild(menuImage)
            })
        }
    }

    addFirstActiveClass (event) {
        event.target.classList.add('first-active')
    }

    removeFirstActiveClass () {
        const activeMenus = document.querySelectorAll('.mtt-mega-menu.first-active')
        activeMenus.forEach(menu => menu.classList.remove('first-active'))
    }
}
